import { render } from "./ScholarshipsFavorites.vue?vue&type=template&id=d455c3f8&scoped=true"
import script from "./ScholarshipsFavorites.vue?vue&type=script&lang=js"
export * from "./ScholarshipsFavorites.vue?vue&type=script&lang=js"

import "./ScholarshipsFavorites.vue?vue&type=style&index=0&id=d455c3f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d455c3f8"]])

export default __exports__